import React from 'react';
import { AgendaFretesPanel } from '../components/agenda/AgendaFretesPanel';

export function AgendaFretesPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <AgendaFretesPanel />
    </div>
  );
}
